import React, { useState, useEffect } from 'react';
import Pagination from "react-js-pagination";

import {
  Box,
  HStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  Spinner,
  Input,
  Flex,
  Center,
  Text,
  Tooltip,
  Button,
  Icon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody
} from '@chakra-ui/react';
import CustomModalLink from '../components/CustomModalLink'
import { SearchIcon } from '@chakra-ui/icons'
import { LuWebhook } from 'react-icons/lu'
import { fetchWrapper } from '../helpers';
import moment from 'moment';
import Header from '../components/Header'
import { getUserFromToken } from '../components/authHelper';
import CreateWebHook from './CreateWebHook';
import WebhookView from './WebhookView';
import 'moment-timezone';

import usePagePermissions from '../hooks/usePagePermissions';
import BoxWrapper from '../components/BoxWrapper/BoxWrapper';
import PageHeading from '../components/shared/PageHeading';

export const getUserTimeZone = () => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return userTimeZone
}


function List({ header }) {

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [list, setList] = useState([])
  const [date, setDate] = useState('')

  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [listCount, setListCount] = useState(0);

  const [customer, setCustomer] = useState('')

  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedQuery, setDebouncedQuery] = useState('');


  const [modelHeader, setModelHeader] = useState('')
  const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [modalEditView, setModalEditView] = useState(false)
  const { onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const [isOpenWebhook, setOpenWebhook] = useState(false);
  const user = JSON.parse(localStorage.getItem('customer'))
  const { loading: permissionsLoading, can } = usePagePermissions('webhook');
  const onOpenWebhook = () => {
    setOpenWebhook(true);
  }
  const onCloseWebhook = () => {
    setOpenWebhook(false);

  };


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery); // Only update debouncedQuery after 500ms
    }, 500); // 500ms debounce

    return () => clearTimeout(handler); // Clear timeout if user types again
  }, [searchQuery]);


  const meClose = () => {

    onClose();
  }
  useEffect(() => {
    if (permissionsLoading || !can('webhook-list')) return;
    const user = getUserFromToken();
    setCustomer(user);
    const id = user.customer_id;
    loadlist(id, date, debouncedQuery); // use debouncedQuery here instead of date/searchQuery
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsLoading, debouncedQuery, activePage]); // Re-run whenever search or page changes


  const loadlist = async (id, date = "", debouncedQuery = "") => {
    setLoading(true)
    try {
      const formattedDate = date ? moment(date).format('YYYY-MM-DD') : "";

      const url = `${process.env.REACT_APP_API_URL}/webhook/list?date=${date}&page=${activePage}&pageSize=10&message_id=${debouncedQuery}`;

      const data = await fetchWrapper.get(url);
      setList(data.data);
      setListCount(data.count)
    } finally {
      setLoading(false)
    }
  }

  // Re-fetch with whatever filters are currently active, rather than the
  // caller having to know/pass them — CreateWebHook only called loadlist(id)
  // after saving, which left date/debouncedQuery as `undefined` and turned
  // into a literal "message_id=undefined" filter that matched nothing.
  const reloadList = () => loadlist(customer?.customer_id, date, debouncedQuery);


  const onChangePaginate = (pageNumber) => {
    setActivePage(pageNumber);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // adds smooth transition
    });
    // to set offset

  };

  const meCloseEdit = () => {
    setIsOpenEdit(false)
    // onClose();    
  }

  const meVeiw = (type, rs) => {
    if (type === "veiw_data") {
      setIsOpenEdit(true);
      setModelHeader('Data Posted')
      setModalEditView(<WebhookView meCloseEdit={meCloseEdit} rs={rs} type={type} />);
    }

    if (type === "veiw_response") {
      setIsOpenEdit(true);
      setModelHeader('Response')
      setModalEditView(<WebhookView meCloseEdit={meCloseEdit} rs={rs} type={type} />);
    }

  }

  const listPermission = can("webhook-list")
  const configurePermission = can("webhook-configure")


  if (permissionsLoading || loading || !list) {
    return (
      <>
        <Header />
        <BoxWrapper>
          <Flex justify="center" align="center" h="300px">
            <Spinner size="lg" />
          </Flex>
        </BoxWrapper>
      </>
    );
  }
  return (
    <>

      <CustomModalLink
        showModalButtonText={modelHeader}
        modalHeader={modelHeader}
        isOpenEdit={isOpenEdit}
        onCloseEdit={meCloseEdit}
        onOpenEdit={onOpenEdit}

        modalBody={modalEditView}
      />

      {loading &&
        <HStack width="100%" h="100vh" top="0" left="0" bg="rgba(204, 204, 204, 0.5)" position="absolute" zIndex="9999" justifyContent="center">
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.500'
            size='xl'
          />
        </HStack>
      }
      <Header header={header} />
      <BoxWrapper>
        <PageHeading icon={LuWebhook} title="WebHook Logs" subtitle="Review the webhook calls sent to your endpoints and their responses" />

        <HStack justifyContent="space-between" mb="25px">
          {listPermission && (
            <Box position="relative" flex="1" maxW="30%">
              <Input
                placeholder="Search by message_id"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                pl={10}
                bg="gray.50"
                border="1px"
                borderColor="gray.200"
              />
              <SearchIcon
                position="absolute"
                left={3}
                top="50%"
                transform="translateY(-50%)"
                color="gray.400"
              />
            </Box>
          )}




          <Box>
            <HStack >
              {configurePermission && (
                <Box>
                  <Button
                    className='custom-chakra-button' padding="20px" fontSize="14px" fontWeight="400"
                    fontFamily="Lato, sans-serif" color="#fff" background="var(--brand-primary)"
                    _hover={{ background: 'var(--brand-primary-hover)' }}
                    onClick={onOpenWebhook}
                  >
                    Configure DLR Web Hook
                  </Button>

                  <Modal isOpen={isOpenWebhook} onClose={onCloseWebhook} isCentered size="lg">
                    <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
                    <ModalContent borderRadius="16px" overflow="hidden">
                      <ModalHeader borderBottom="1px solid" borderBottomColor="gray.100" py={4} px={5}>
                        <HStack spacing={3}>
                          <Box
                            w="40px" h="40px" borderRadius="10px"
                            bg="rgb(var(--brand-primary-rgb) / 0.1)"
                            display="flex" alignItems="center" justifyContent="center"
                            flexShrink={0}
                          >
                            <Icon as={LuWebhook} color="var(--brand-primary)" boxSize={6} />
                          </Box>
                          <Box>
                            <Text fontSize="15px" fontWeight="700" color="gray.800">Configure Webhook</Text>
                            <Text fontSize="11.5px" color="gray.500" fontWeight="400">
                              Real-time delivery status updates, posted to your system
                            </Text>
                          </Box>
                        </HStack>
                      </ModalHeader>
                      <ModalCloseButton top={4} right={5} />
                      <ModalBody px={5} py={5}>
                        <CreateWebHook meClose={meClose} setOpenWebhook={setOpenWebhook} customer={user} loadList={reloadList} />
                      </ModalBody>
                    </ModalContent>
                  </Modal>
                </Box>
              )}



            </HStack>

          </Box>
        </HStack>

        {listPermission ? <div className="box-style-card">
          <TableContainer width="100%">
            <Table variant='simple' width="100%" >
              <Thead >
                <Tr>
                  <Th>Message ID</Th>
                  <Th>Date & Time</Th>

                  <Th>Channel</Th>

                  <Th>Url</Th>
                  <Th>Data Posted</Th>
                  <Th>Response</Th>




                </Tr>
              </Thead>

              <Tbody fontSize="14px">

                {list?.length > 0 ? list.map((rs, index) => {
                  return (

                    <Tr key={index}>
                      <Td>{rs?.message_id ? rs?.message_id : "-"}
                      </Td>
                      <Td>
                        {moment
                          .unix(JSON.parse(rs.data_posted).date_time) // parse Unix timestamp (in seconds)
                          .tz(getUserTimeZone())                      // apply user timezone
                          .format('DD/MM/YY | hh:mm:ss A')}
                      </Td>


                      <Td>{JSON.parse(rs.data_posted)?.channel}</Td>


                      <Td maxW="220px">
                        {rs.url ? (
                          <Tooltip label={rs.url} placement="top" hasArrow>
                            <Text isTruncated>{rs.url}</Text>
                          </Tooltip>
                        ) : "-"}
                      </Td>
                      <Td onClick={() => meVeiw('veiw_data', rs)} style={{ color: '#1F5AF4', cursor: 'pointer' }}> View</Td>
                      <Td onClick={() => meVeiw('veiw_response', rs)} style={{ color: '#1F5AF4', cursor: 'pointer' }}>View</Td>

                    </Tr>
                  )

                }) : ""}

              </Tbody>


            </Table>
            <Flex justifyContent="center" alignItems="center" my={4}>
              <Pagination
                activePage={activePage}
                itemsCountPerPage={50}
                totalItemsCount={listCount}
                pageRangeDisplayed={5}
                onChange={onChangePaginate}
                itemClass="page-item"
                linkClass="page-link"
                innerClass="pagination"

              />
            </Flex>
          </TableContainer>
        </div> : <BoxWrapper>
          <Center h="400px">
            <Box textAlign="center">
              <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                No Access
              </Text>
              <Text fontSize="sm" color="gray.500">
                You don't have permission to view this sections.
              </Text>
            </Box>
          </Center>
        </BoxWrapper>}


      </BoxWrapper>
    </>
  )
}

export default List;